<template>
  <div class="text-center">
    <v-dialog
      v-model="value.active"
      max-width="1400"
      persistent
      scrollable
    >
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
      >
        <form @submit.prevent="validar()">
          <v-card>
            <v-card-title class="dialog-problema-titulo text-h5">
              <h3>
                {{
                  value.problema.CodProblema ? `Editando: ` : 'Nuevo Problema'
                }}
              </h3>
              <span
                v-if="value.problema.NombreProblema"
                v-html="value.problema.NombreProblema"
              />
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col class="col-12">
                  <v-row>
                    <v-col class="col-12 col-md-6">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|max:100"
                        name="El Problema debe incluir un nombre"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label
                              v-bind="attrs"
                              class="grey--text"
                              v-on="on"
                            >
                              Nombre
                            </label>
                          </template>
                          <span>Nombre del Tipo de Problema</span>
                        </v-tooltip>
                        <v-text-field
                          v-model="value.problema.NombreProblema"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>
                    <v-col class="col-12 col-md-6">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|max:50"
                        name="El Problema debe incluir un enlace"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label
                              v-bind="attrs"
                              class="grey--text"
                              v-on="on"
                            >
                              Enlace<span class="label-span">
                                (<b>formato:</b>
                                nuevo-tipo-problema-enlace)</span>
                            </label>
                          </template>
                          <span>URL que se asignará al Tipo de Problema</span>
                        </v-tooltip>
                        <v-text-field
                          v-model="value.problema.ToLink"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>
                    <v-col class="col-12 col-sm-6">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|max:150"
                        name="Debe seleccionar un Título H1"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label
                              v-bind="attrs"
                              class="grey--text"
                              v-on="on"
                            >
                              Título H1
                            </label>
                          </template>
                          <span>Título Principal de la estructura SEO</span>
                        </v-tooltip>
                        <v-text-field
                          v-model="value.problema.H1Titulo"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>
                    <v-col class="col-12 col-md-6">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|max:250"
                        name="El Problema debe incluir un Meta Title"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label
                              v-bind="attrs"
                              class="grey--text"
                              v-on="on"
                            >
                              Meta Title
                            </label>
                          </template>
                          <span>Título a mostrar en pestaña (considerar SEO)</span>
                        </v-tooltip>

                        <v-text-field
                          v-model="value.problema.MetaTitle"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>
                    <v-col
                      v-if="value.problema.Imagen"
                      class="col-12 col-md-6"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <label
                            v-bind="attrs"
                            class="label-img"
                            v-on="on"
                          >Imagen actual: <span
                            v-html="value.problema.Imagen"
                          /></label>
                        </template>
                        <span>La imagen actual del Poblema. Puede cambiarla en el
                          box "Cambiar Imagen"</span>
                      </v-tooltip>
                    </v-col>
                    <v-col class="col-12 col-md-6">
                      <validation-provider
                        v-slot="{ errors }"
                        name="Archivo"
                        rules="ext:jpg,png|size:1000"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label
                              v-bind="attrs"
                              class="grey--text"
                              v-on="on"
                              v-html="
                                value.problema.Imagen
                                  ? 'Cambiar Imagen'
                                  : 'Subir Imagen'
                              "
                            />
                          </template>
                          <span>Cambia la imagen actual asociada al Problema</span>
                        </v-tooltip>
                        <v-file-input
                          v-model="value.imagen"
                          small-chips
                          :error-messages="errors"
                          label="Formato: jpg, png (1200x400px sugeridos)"
                          dense
                          filled
                          color="success"
                        />
                      </validation-provider>
                    </v-col>
                                        <v-col class="col-12 col-sm-6">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|max:150"
                        name="Debe seleccionar un Título para la Sección Causas"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label
                              v-bind="attrs"
                              class="grey--text"
                              v-on="on"
                            >
                              Atributo "ALT" de la imagen (SEO)
                            </label>
                          </template>
                          <span>Este atributo es un texto y se utiliza a describir la imagen</span>
                        </v-tooltip>
                        <v-text-field
                          v-model="value.problema.ImagenAlt"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>
                    <v-col class="col-12 col-sm-6">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|max:150"
                        name="Debe seleccionar un Título para la Sección Causas"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <label
                              v-bind="attrs"
                              class="grey--text"
                              v-on="on"
                            >
                              Atributo "Title" de la imagen (SEO)
                            </label>
                          </template>
                          <span>Este atributo es un texto y se utiliza a describir la imagen</span>
                        </v-tooltip>
                        <v-text-field
                          v-model="value.problema.ImagenTitle"
                          :error-messages="errors"
                          color="success"
                          type="text"
                          filled
                          dense
                        />
                      </validation-provider>
                    </v-col>
                    <v-col class="col-12">
                      <h4>Descripción</h4>
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required|max:8000"
                        name="Descripcion"
                      >
                        <vue-editor
                          v-model="value.problema.Descripcion"
                          :error-messages="errors"
                          :editor-toolbar="editorToolbarOptions"
                        />
                      </validation-provider>
                    </v-col>











                    <v-col class="row-breakdown-items">
                      <v-row class="row-breakdown-items__title">
                        <v-col class="main">
                          <h3>
                            Meta Tags
                            <v-icon dark>
                              {{ $vuetify.icons.values.tagPlus }}
                            </v-icon>
                          </h3>
                          <v-btn
                            color="info"
                            :small="$vuetify.breakpoint.xs"
                            @click="abrirCrearMetaTag()"
                          >
                            <v-icon>
                              {{ $vuetify.icons.values.plusBox }}
                            </v-icon>
                            Crear Nuevo MetaTag
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row class="row-breakdown-items__content">
                        <v-col class="col-12">
                          <v-row class="row-breakdown-items__form">
                            <v-col class="col-12 col-md-6 inputs">
                              <v-text-field
                                v-model="value.metaTagBox.name"
                                label="Name"
                                solo
                              />
                              <v-text-field
                                v-model="value.metaTagBox.content"
                                label="Content"
                                solo
                              />
                              <v-btn
                                v-if="value.metaTagModoCreacion"
                                color="info"
                                @click="crearMetaTag()"
                              >
                                Crear
                              </v-btn>
                              <v-btn
                                v-else
                                @click="editarMetaTag()"
                              >
                                editar
                              </v-btn>
                            </v-col>
                            <v-col class="col-12 col-md-6 alerts">
                              <div class="alert-main">
                                <v-alert
                                  v-if="showMsgMetaTag"
                                  dense
                                  text
                                  :type="typeMsgMetaTag"
                                >
                                  <span v-html="msgMetaTag" />
                                </v-alert>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row
                            class="row-breakdown-items__table justify-center"
                          >
                            <v-col class="col-12">
                              <div class="divider" />
                            </v-col>
                            <v-col
                              v-if="
                                value.problema.MetaTags != undefined &&
                                  value.problema.MetaTags.length > 0
                              "
                              class="col-12 col-md-9 mt-5 mb-5 table-main"
                            >
                              <v-simple-table dense>
                                <template v-slot:default>
                                  <thead>
                                    <tr>
                                      <th class="text-left">
                                        Name
                                      </th>
                                      <th class="text-left">
                                        Content
                                      </th>
                                      <th>
                                        Editar
                                      </th>
                                      <th>
                                        Eliminar
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="(item, i) in value.problema.MetaTags"
                                      :key="i"
                                    >
                                      <td>{{ item.Name }}</td>
                                      <td>{{ item.Content }}</td>
                                      <td class="td-btn">
                                        <v-btn
                                          color="info"
                                          small
                                          @click="
                                            abrirEditarMetaTag(
                                              value.problema.MetaTags.indexOf(
                                                item
                                              )
                                            )
                                          "
                                        >
                                          <v-icon>{{ $vuetify.icons.values.menuDown }}</v-icon>
                                        </v-btn>
                                      </td>
                                      <td class="td-btn">
                                        <v-btn
                                          color="info"
                                          small
                                          @click="
                                            eliminarMetaTag(
                                              value.problema.MetaTags.indexOf(
                                                item
                                              )
                                            )
                                          "
                                        >
                                          <v-icon>{{ $vuetify.icons.values.delete }}</v-icon>
                                        </v-btn>
                                      </td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-col>
                            <v-col
                              v-else
                              class="no-breakdown-items"
                            >
                              Aún no has añadido metatags a este tipo de problema
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>








                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="green darken-1"
                text
                @click="cerrar()"
              >
                Cerrar
              </v-btn>
              <v-btn
                color="success"
                default
                type="submit"
                :disabled="invalid"
                :loading="value.loader"
              >
                Grabar
              </v-btn>
            </v-card-actions>
          </v-card>
        </form>
      </validation-observer>
    </v-dialog>
  </div>
</template>

<script>
// import Vue from 'vue'
  import { VueEditor } from 'vue2-editor'
  export default {
    name: 'ShowDialogTipoProblema',
    components: {
      VueEditor,
    },
    props: {
      value: {
        active: {
          type: Boolean,
          default: false,
        },
        problema: {
          type: Object,
          default: false,
        },
        imagen: {
          type: Object,
          default: false,
        },
        loader: {
          type: Boolean,
          default: false,
        },
        metaTagBox: {
          type: Object,
          default: {},
          name: {
            type: String,
            default: '',
          },
          content: {
            type: String,
            default: '',
          },
        },
        metaTagModoCreacion: {
          type: Boolean,
          default: true,
        },
        default: null,
        type: Object,
      },
    },
    data () {
      return {
        showMsgMetaTag: false,
        editorToolbarOptions: require('@/data/editorToolbarOptions.json'),
      }
    },
    watch: {
      'value.active': function (value) {
        requestAnimationFrame(() => {
          // Reseteamos vee al cerrar dialog
          this.$refs.observer.reset()
        })
      },
    },
    methods: {
      validar () {
        this.$emit('procesar', this.value)
      },
      cerrar () {
        this.$emit('cerrar')
      },
      abrirEditarMetaTag (index) {
        console.log(`abrirEditar MetaTag ${index}`)
        this.metaTagIdEditar = index
        this.value.metaTagModoCreacion = false
        this.value.metaTagBox.name = this.value.problema.MetaTags[index].Name
        this.value.metaTagBox.content = this.value.problema.MetaTags[index].Content
      },
      abrirCrearMetaTag () {
        this.value.metaTagModoCreacion = true
        this.value.metaTagBox = {
          name: '',
          content: '',
        }
      },
      crearMetaTag () {
        const element = {
          Name: this.value.metaTagBox.name,
          Content: this.value.metaTagBox.content,
        }
        if (!this.value.problema.MetaTags) this.value.problema.MetaTags = []
        this.value.problema.MetaTags.unshift(element)
        this.limpiaMetaTagBox()
        this.showAlertMetaTag(
          'Registro creado. Debe grabar para guardar cambios definitivamente',
          'success',
        )
      },
      async editarMetaTag () {
        this.value.problema.MetaTags[
          this.metaTagIdEditar
        ].Content = this.value.metaTagBox.content
        this.value.problema.MetaTags[
          this.metaTagIdEditar
        ].Name = this.value.metaTagBox.name
        this.limpiaMetaTagBox()
        this.showAlertMetaTag(
          'Registro editado. Debe grabar para guardar cambios definitivamente',
          'success',
        )
      },
      eliminarMetaTag (index) {
        if (confirm('¿Estás seguro/a que deseas eliminar este MetaTag?')) {
          this.value.problema.MetaTags.splice(index, 1)
          this.limpiaMetaTagBox()
          if (this.value.problema.MetaTags.length === 0) {
            this.value.problema.MetaTags = 0
          }
          this.showAlertMetaTag(
            'Registro eliminado. Debe grabar para guardar cambios definitivamente',
            'warning',
          )
        }
      },
      showAlertMetaTag (msg, type) {
        this.msgMetaTag = msg
        this.typeMsgMetaTag = type
        this.showMsgMetaTag = true
        setTimeout(() => {
          this.msgMetaTag = ''
          this.typeMsgMetaTag = ''
          this.showMsgMetaTag = false
        }, 6000)
      },
      limpiaMetaTagBox () {
        this.value.metaTagModoCreacion = true
        this.value.metaTagBox.name = ''
        this.value.metaTagBox.content = ''
        this.metaTagIdEditar = false
      },
    },
  }
</script>

<style lang="sass" scoped>
@import '@/sass/variables2'

.pre-formatted
  white-space: pre

.validation-error-box
  border: 1px solid #ff6668

.validation-error-title
  color: #ff6668

.ql-editor
  height: 200px !important

.chk-problemas__main
  overflow-y: scroll
  height: 1220px

  .label-img
  color: #9e9e9e
  span
    color: $orange

.label-img
  color: #9e9e9e
  span
    color: $orange
.v-card
  .dialog-problema-titulo
    h3
      color: $green !important
      display: inline
    span
      color: #9e9e9e
      text-transform: capitalize
      font-weight: bold
.label-span
  font-size: 13px !important
  color: $green

.row-breakdown-items__content
  background: $lightblack4
  .row-breakdown-items__form
    .inputs
      display: flex
      flex-direction: column
      justify-content: space-between
      padding: 20px
      .v-btn
        margin-right: 0px
        width: 200px
    .alerts
      display: flex
      flex-direction: column
      justify-content: space-between
      padding: 20px
      .alert-main
        height: 50px
      span
        font-weight: 300 !important
        font-size: 14px
      .v-btn
        margin-right: 0px
        width: 200px
  .row-breakdown-items__table
    .td-btn
      width: 50px
    .divider
      width: 100%
      height: 2px
      background: $lightblack3
    .table-main
      background: $white
    .no-breakdown-items
      text-align: center
      padding: 20px
      background: $lightblack4
</style>


